import type { ViewUIDatePicker } from '@salescore/core'
import { DatePicker, message } from 'antd'
import dayjs from 'dayjs'
import { t } from 'i18next'
import { useContext } from 'react'

import { useViewUIRecordNodeContext } from './contexts'
import { ViewUIContext } from './ViewUIComponent'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ViewUIDatePickerC({ component }: { component: ViewUIDatePicker }) {
  const { isEditMode } = useContext(ViewUIContext)
  const { getValue, onChange } = useViewUIRecordNodeContext()
  const value = getValue(component.fieldName)
  const datetime = typeof value === 'string' ? dayjs(value) : undefined
  return (
    <DatePicker
      value={datetime}
      onChange={(value) => {
        const formatedDate =
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          component.showTime === true ? value?.format('YYYY-MM-DDTHH:mm:ss.000+09:00') : value?.format('YYYY-MM-DD')
        onChange({ fieldName: component.fieldName, value: formatedDate })
      }}
      showTime={component.showTime === true ? { format: `HH:mm:ss` } : undefined}
      minuteStep={
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        component.minuteStep as 1 | undefined
        // eslint-disable-next-line sonarjs/todo-tag
      } // TODO
      onClick={() => {
        if (component.readonly === true) {
          void message.warning(t(`この項目は書き込みが禁止されています。`))
        }
      }}
      disabled={isEditMode || component.readonly}
    />
  )
}
